export const PRICES = {
    "XXS": 0,
    "XS": 0.99,
    "S": 1.49,
    "M": 2.49,
    "L": 4.49,
    "XL": 6.49,
    "custom": 6.99,
};

export const FORMATS = {
    "4:3": {
        XXS: "7x5,25",
        XS: "14x10,5",
        S: "28x21",
        M: "40x30",
        L: "80x60",
        XL: "100x75"
    },
    "3:2": {
        XXS: "7,5x5",
        XS: "15x10",
        S: "30x20",
        M: "60x40",
        L: "90x60",
        XL: "105x70"
    },
    "16:9": {
        XXS: "8x4,5",
        XS: "16x9",
        S: "32x18",
        M: "64x36",
        L: "112x64",
        XL: "128x72"
    },
    "DIN": {
        XXS: "7,4x5,2",
        XS: "14,8x10,5",
        S: "29,7x21",
        M: "42x29,7",
        L: "84,1x59,4",
        XL: "118,9x84,1"
    },
    "1:1": {
        XXS: "7,5x7,5",
        XS: "13x13",
        S: "30x30",
        M: "50x50",
        L: "80x80",
        XL: "100x100"
    }
};